import React from 'react';
import { Link } from 'react-router-dom';
import { Folder, Images, Video, Globe2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type Kind = 'images' | 'videos' | 'panos';

const iconForKind: Record<Kind, React.ReactNode> = {
  images: <Images className="w-6 h-6" />,
  videos: <Video className="w-6 h-6" />,
  panos: <Globe2 className="w-6 h-6" />
};

interface FolderCardProps {
  slug: string;
  kind: Kind;
  count: number;
}

const FolderCard: React.FC<FolderCardProps> = ({ slug, kind, count }) => {
  const { t } = useTranslation();
  const href = `/p/${slug}/${kind}`;
  const kindLabel = kind === 'panos' ? t('qr.panos') : t(`qr.${kind}`);

  return (
    <Link
      to={href}
      className="group bg-[#232323] border border-[#2f2f2f] rounded-xl p-6 flex items-center justify-between hover:border-[#C8102E] transition-colors duration-200"
    >
      <div className="flex items-center gap-3 text-[#E0E0E0]">
        <div className="w-12 h-12 rounded-lg bg-[#1a1a1a] flex items-center justify-center text-[#C8102E]">
          {iconForKind[kind] || <Folder className="w-6 h-6" />}
        </div>
        <div>
          <p className="text-lg font-semibold capitalize">{kindLabel}</p>
          <p className="text-sm text-[#AAAAAA]">{count} {t('common.items')}</p>
        </div>
      </div>
      <span className="text-[#C8102E] opacity-0 group-hover:opacity-100 transition-opacity duration-200">
        {t('common.open')}
      </span>
    </Link>
  );
};

export default FolderCard;
